import * as React from 'react'
import { SVGProps } from 'react'
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 22.4 48.3" {...props}>
    <path d="M22.4 15.6h-7.6v-5a2 2 0 0 1 2.1-2.3h5.4V0h-7.4C6.6 0 4.8 6.2 4.8 10.1v5.5H0v8.5h4.8v24.2h10V24.2h6.8z" />
  </svg>
)
export default SvgFacebook
